'use strict';

module.exports = {
    'lang': 'zh-cn',
    'total': '共',
    'items': '条',
    'show': '显示',
    'goto': '跳至',
    'page': '页',
    'ok': '确认',
    'en-us': {
        'total': 'total',
        'items': 'items',
        'show': 'page',
        'goto': 'goto',
        'ok': 'ok'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/_bee-pagination@1.1.5@bee-pagination/build/i18n.js
// module id = 480
// module chunks = 0